module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('br'), _vm._v(" "), _c('h2', [_vm._v("Sharers Summary")]), _vm._v(" "), (_vm.sharers.length >= 0) ? _c('sharers-bar-chart', {
    attrs: {
      "sharer-data": _vm.sharers
    }
  }) : _vm._e(), _vm._v(" "), _c('data-table', {
    attrs: {
      "table-ref": "sharingtable",
      "title": "",
      "title-heading": "h2",
      "icon": "fa fa-users",
      "url": "stats/org/20/null/telco",
      "sort-field": "sitesTotal",
      "sort-direction": "desc",
      "show-search": false,
      "hide-org-badge": _vm.hideOrgBadge,
      "title-class": _vm.titleClass,
      "fields": _vm.fields,
      "stripe": "",
      "track-by": "organisation_id"
    },
    scopedSlots: _vm._u([{
      key: "details",
      fn: function(scope) {
        return [_c('popup-sharer-stats', {
          attrs: {
            "row-data": scope.rowData
          }
        })]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361414f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/SharingSummaryReport.vue
// module id = 1496
// module chunks = 0